import { render, staticRenderFns } from "./AddChapter.vue?vue&type=template&id=0047a66c&scoped=true"
import script from "./AddChapter.vue?vue&type=script&lang=js"
export * from "./AddChapter.vue?vue&type=script&lang=js"
import style0 from "./AddChapter.vue?vue&type=style&index=0&id=0047a66c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0047a66c",
  null
  
)

export default component.exports